const BaseView = require('../lib/model-binder');
const _ = require('underscore');
const SubtitleSync = require('./subtitle-display');
const template = require('../templates/player.jade');
const reader = require('../helpers/reader');
const dispatcher = require('../dispatcher');
const parent = BaseView.prototype;

module.exports = BaseView.extend({
	autoRender: true,
	template: template(),
	progressMouseDown: false,
	volumeMouseDown: false,
	hasStop: null,
	playerTimer: null,
	_freezeWatchdog: null,
	_lastWatchdogTime: null,
	events: {
		'click video': 'togglePlayPause',
		'click .play': 'playVideo',
		'click .pause': 'pauseVideo',
		'click .stop': 'stopVideo',
		'click .ff10f': 'ff10fVideo',
		'click .fb10f': 'fb10fVideo',
		'click .ff1f': 'ff1fVideo',
		'click .fb1f': 'fb1fVideo',
		'click .speed-up': 'updateSpeed',
		'click .speed-down': 'updateSpeed',
		'click .full-screen': 'fullScreenVideo',
		'click .cc': 'ccToggle',
		'click .black-bg': 'blackBg',

		'mousedown .progress-bar': 'seekToPosition',
		'mousemove .progress-bar': 'seekToPosition',
		'mouseup .progress-bar': 'seekToPosition',
		'mouseleave .progress-bar': 'seekToPosition',
		'mousedown .vol-bar': 'updateVolume',
		'mousemove .vol-bar': 'updateVolume',
		'mouseup .vol-bar': 'updateVolume',
		'mouseleave .vol-bar': 'updateVolume',
		'click .vol-up': 'volumeUp',
		'click .vol-down': 'volumeDown'
	},
	initialize: function (options) {
		_.extend(this, options);

		parent.initialize.apply(this, arguments);

		_.bindAll(this, 'videoTimeUpdated', 'finishedLoading', 'startedPlaying', 'pauseVideo');

		if (this.autoRender) this.render();

		var debouncedEdit = _.debounce(_.bind(function () {
			this.checkInitData();
			this.initEventListeners();
		}, this), 500);
		debouncedEdit();
		
		localStorage.setItem("selected-subtitle", 0);
	},
	initEventListeners: function () {
	    this.listenTo(dispatcher, dispatcher.events.PLAY_SUBTITLE, this.playSubtitle);
		this.listenTo(dispatcher, dispatcher.events.PLAY_SECTION, this.playSection);
		this.listenTo(dispatcher, dispatcher.events.JUMP_TO_FRAME, this.jumpToFrame);
		this.listenTo(dispatcher, dispatcher.events.REQUEST_PLAY_TIME_CHANGE, this.jumpToTime)

		this.listenTo(dispatcher, dispatcher.events.PLAY_VIDEO, this.togglePlayPause);
		this.listenTo(dispatcher, dispatcher.events.PAUSE_VIDEO, this.pauseVideo);

		this.listenTo(dispatcher, dispatcher.events.SKIP_FORWARD_1, this.ff1fVideo);
		this.listenTo(dispatcher, dispatcher.events.SKIP_BACKWARD_1, this.fb1fVideo);

		this.listenTo(dispatcher, dispatcher.events.SCROLL_UP, this.updateScrollPosition);
		this.listenTo(dispatcher, dispatcher.events.SCROLL_DOWN, this.updateScrollPosition);

		this.listenTo(dispatcher, dispatcher.events.VOLUME_UP, this.updateVolume);
		this.listenTo(dispatcher, dispatcher.events.VOLUME_DOWN, this.updateVolume);

		var toggleFullscreen = _.bind(function (e) {
			var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

			if (state) {
				this.$el.addClass('fullscreen');

				dispatcher.emit(dispatcher.events.DISABLE_KEYBOARD_CONTROLS);
			} else {
				this.$el.removeClass('fullscreen');

				dispatcher.emit(dispatcher.events.ENABLE_KEYBOARD_CONTROLS);
			}
		}, this);

		document.addEventListener("fullscreenchange", toggleFullscreen);
		document.addEventListener("webkitfullscreenchange", toggleFullscreen);
		document.addEventListener("mozfullscreenchange", toggleFullscreen);
		document.addEventListener("MSFullscreenChange", toggleFullscreen);
	},
	render: function () {
		this.setElement(this.template);

		this.modelBinder.bind(this.model, this.el, {
			videoSrc: {
				selector: 'source',
				elAttribute: 'src'
			}
		});

		this.initSubtitleOnVideo();
		this.initVideoEvents();

		return this;
	},
	checkInitData: function () {
		this.updateVolumeIndicator();

		var progress = 0;
		var volume = 1;

		localStorage.setItem('capNsub-player-progress' ,this.model.get('position'));

		if (localStorage.hasOwnProperty('capNsub-player-progress'))
			progress = localStorage.getItem('capNsub-player-progress');

		if (localStorage.hasOwnProperty('capNsub-player-volume'))
			volume = localStorage.getItem('capNsub-player-volume');

		if (progress >= 0) {
			this.$video.currentTime = progress;
			this.videoTimeUpdated();
		}

		if (volume) {
			this.$video.volume = volume;
			this.updateVolumeIndicator();
		}
	},
	initVideoEvents: function () {
		this.$video = this.$('video')[0];
		this.$video.onloadedmetadata = this.finishedLoading;
		this.$video.onplaying = this.startedPlaying;
		this.$video.onpause = this.pauseVideo;

		this.$video.onwaiting = _.bind(function () {
			clearInterval(this.playerTimer);
		}, this);
	},
	startedPlaying: function () {
		this.$el.addClass('playing').removeClass('paused').removeClass('stopped');
		var interval = 1000 / reader.frameRate;

		this.playerTimer = setInterval(this.videoTimeUpdated, interval);
		this._startFreezeWatchdog();
	},	
	videoTimeUpdated: function () {
		dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY);

		this.updateProgressBar();
		this.updateCurrentTime();

		//Stick to a frame
		var currentTime = this.$video.currentTime;
		var frameRate = this.model.get('frameRate');
		var stickyTime = Math.floor(currentTime * frameRate + 0.1) / frameRate;
		localStorage.setItem('capNsub-player-progress', stickyTime);

		dispatcher.emit(dispatcher.events.NEW_PLAY_TIME, stickyTime);
		
		if (this.$video.currentTime >= this.hasStop && this.hasStop) {
			clearInterval(this.playerTimer);
			this.hasStop = null;
			this.pauseVideo();
		}
	},
	jumpToFrame: function (frames) {
		this.jumpToTime(reader.framesToTime(frames));
	},
	jumpToTime: function(time) {
		if (this.$video.currentTime == time) {
			return; //Added for performance issues
		}
		this.$video.currentTime = time;
		this.videoTimeUpdated();
	},
	playVideo: function () {
		this.$video.play();
	},
	stopVideo: function () {
		this.pauseVideo();
		this.$video.currentTime = 0;
		this.$video.playbackRate = 1;
		this.videoTimeUpdated();
		clearInterval(this.playerTimer);
	},
	pauseVideo: function () {
		clearInterval(this._freezeWatchdog);
		this._lastWatchdogTime = null;
		this.$video.playbackRate = 1;
		this.$('.speed').html('1x');
		this.$video.pause();

		//Stick to a frame
		var currentTime = this.$video.currentTime;
		var frameRate = this.model.get('frameRate');
		var stickyTime = Math.floor(currentTime * frameRate + 0.1) / frameRate;

		localStorage.setItem('capNsub-player-progress', stickyTime);

		this.$video.currentTime = stickyTime;

		this.videoTimeUpdated();

		this.$el.addClass('paused').removeClass('playing').removeClass('stopped');

		clearInterval(this.playerTimer);
	},
	_startFreezeWatchdog: function () {
		clearInterval(this._freezeWatchdog);
		this._lastWatchdogTime = null;
		this._freezeWatchdog = setInterval(_.bind(function () {
			if (this.$video.paused) return;
			var currentTime = this.$video.currentTime;
			if (this._lastWatchdogTime !== null && currentTime === this._lastWatchdogTime) {
				// Playback is frozen - skip forward 1 second to find the nearest keyframe
				var skipTo = currentTime + 1.0;
				if (skipTo < this.$video.duration) {
					this.$video.currentTime = skipTo;
				}
			}
			this._lastWatchdogTime = currentTime;
		}, this), 2000);
	},
	ff1fVideo: function () {
		const insureFrameJumpFactor =  0.00001;
		this.pauseVideo();
		this.$video.currentTime += 1 / this.model.get('frameRate') + insureFrameJumpFactor; 
		this.videoTimeUpdated();
	},
	fb1fVideo: function () {
		const insureFrameJumpFactor =  0.00001;
		this.pauseVideo();
		this.$video.currentTime -= 1 / this.model.get('frameRate') - insureFrameJumpFactor;
		this.videoTimeUpdated();
	},
	ff10fVideo: function () {
		const insureFrameJumpFactor =  0.00001;
		this.pauseVideo();
		this.$video.currentTime += 10 / this.model.get('frameRate') + insureFrameJumpFactor;
		this.videoTimeUpdated();
	},
	fb10fVideo: function () {
		const insureFrameJumpFactor =  0.00001;
		this.pauseVideo();
		this.$video.currentTime -= 10 / this.model.get('frameRate') - insureFrameJumpFactor;
		this.videoTimeUpdated();
	},
	updateSpeed: function (e) {
		var $this = $(e.currentTarget);
		var speed = this.$video.playbackRate;
		var displaySpeed = 1;

		if ($this.hasClass('speed-up') && speed < 8) {
			this.$video.playbackRate = speed * 2;
		} else if ($this.hasClass('speed-down') && speed > 0.125) {
			this.$video.playbackRate = speed / 2;
		}

		speed = this.$video.playbackRate;
		if (speed < 1) displaySpeed = 1 / speed;
		else displaySpeed = speed;

		this.$('.speed').html(displaySpeed + 'x');
	},
	fullScreenVideo: function () {
		var state = !!(document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen);
		const videoWrapper = $('.video-wrapper')[0];

		if (!state) {
			if (videoWrapper.requestFullscreen) {
				videoWrapper.requestFullscreen();
			} else if (videoWrapper.msRequestFullscreen) {
				videoWrapper.msRequestFullscreen();
			} else if (videoWrapper.mozRequestFullScreen) {
				videoWrapper.mozRequestFullScreen();
			} else if (videoWrapper.webkitRequestFullscreen) {
				videoWrapper.webkitRequestFullscreen();
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
		}
	},
	updateProgressBar: function () {
		var progress = ((this.$video.currentTime * 100) / this.$video.duration).toFixed(4);

		var $progressBar = this.$('.video-progress');

		$progressBar.css('width', progress + '%');
	},
	finishedLoading: function () {
		this.$('.time-progress .total').html(reader.toHMS(this.$video.duration));
		this.updateCurrentTime();
		this.updateProgressBar();

	},
	updateCurrentTime: function () {
		this.$('.time-progress .now').html(reader.toHMS(this.$video.currentTime));
	},
	seekToPosition: function (e) {
		if (e.type == 'mousedown') this.progressMouseDown = true;
		if (e.type == 'mouseup' || e.type == 'mouseleave') this.progressMouseDown = false;

		if (e.type == 'mousemove' && !this.progressMouseDown) return;
		if (!this.progressMouseDown) return;

		var $bar = $(e.currentTarget).find('.bar');
		var barOffset = $bar.offset();

		var relX = e.pageX - barOffset.left;

		var progress = (relX * 100) / $bar.width();

		this.$video.currentTime = this.$video.duration * progress / 100;
		this.videoTimeUpdated();
	},
	updateVolume: function (e) {
		var volume;

		if (_.isNumber(e)) {
			volume = this.$video.volume;
			volume += e;
			if (volume < 0) volume = 0;
			else if (volume > 1) volume = 1;

		} else {
			if (e.type == 'mousedown') this.volumeMouseDown = true;
			if (e.type == 'mouseup' || e.type == 'mouseleave') this.volumeMouseDown = false;

			if (e.type == 'mousemove' && !this.volumeMouseDown)
				return;
			if (!this.volumeMouseDown)
				return;

			var $this = $(e.currentTarget);

			var relX = e.pageX - $this.offset().left;

			volume = (relX * 100) / $this.width();
			if (volume > 100 || volume < 0)
				return;

			volume = volume / 100;
		}

		this.$video.volume = volume;
		localStorage.setItem('capNsub-player-volume', volume);

		this.updateVolumeIndicator();
	},

	updateVolumeIndicator: function () {
		var volume;

		if (localStorage.hasOwnProperty('capNsub-player-volume'))
			volume = localStorage.getItem('capNsub-player-volume');
		else volume = this.$video.volume;

		var $rocker = this.$('.vol-level');

		$rocker.css('left', (volume * 100) + '%');
	},
	volumeUp: function () {
		this.updateVolume(0.1);
	},
	volumeDown: function () {
		this.updateVolume(-0.1);
	},

	updateScrollPosition: function (e, jump) {
		if (_.isNumber(e)) {
			var index = parseInt(localStorage.getItem('selected-subtitle'));

			index = index + parseInt(e);

			if (index < 0)
				index = 0;

			if (jump)
				localStorage.setItem('jump', true);

			dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, index, true);
			localStorage.setItem('selected-subtitle', index);



		}
	},

	arrowUp: function () {
		this.updateScrollPosition(-1);
	},
	arrowDown: function () {
		this.updateScrollPosition(+1);
	},

	initSubtitleOnVideo: function () {
		new SubtitleSync({
			el: this.el,
			movieModel: this.model
		})
	},
	playSubtitle: function (model, startPlaying) {
		model = model.getCurrentModel();

		var progress = model.get('frameStart') / reader.frameRate;
		this.$video.currentTime = progress;

		if (typeof startPlaying == 'undefined' || !startPlaying) {
			this.videoTimeUpdated();
			return;
		}

		if (this.$video.paused)
			this.$video.play();
		this.hasStop = model.get('frameEnd') / reader.frameRate;
	},
	playSection: function (model) {
		model = model.getCurrentModel();
		this.hasStop = model.get('frameEnd') / reader.frameRate;

		if (this.$video.paused) {
			var startTime = model.get('frameStart') / reader.frameRate;
			var currentTime = this.$video.currentTime;
			if (startTime > currentTime || currentTime >= this.hasStop) {
				this.$video.currentTime = startTime;
			} 
			this.$video.play();
		} else {
			this.pauseVideo();
		}
	},
	ccToggle: function () {
		this.$('.subtitle-display').toggleClass('hidden');
		this.$('.cc').toggleClass('deactivated');
	},
	togglePlayPause: function () {
		if (this.$video.paused) this.playVideo();
		else this.pauseVideo();
	},
	blackBg: function (e) {

		var blackBg = localStorage.getItem("blackBg");

		if (blackBg == "true") {
			localStorage.setItem("blackBg", false);
			$('.black-bg.active').toggleClass('active');
		} else {
			localStorage.setItem("blackBg", true);
			$('button[class = black-bg]').toggleClass('active');
		}
		dispatcher.emit(dispatcher.events.BLACK_BG);
	},
});


// WEBPACK FOOTER //
// ./app/views/player.js